<template>
  <div style="overflow:auto">
    <h1 class="bd-content-title blue-text">
      <strong>Visualize and Customize User Journeys</strong>
    </h1>
    <p
      class="mb-4"
    >Create automated, cross-channel marketing workflows using a simple, drag-and-drop interface. With Journey Builder, the power is in your hands to sculpt the perfect journey and engage your customers when it matters most.</p>
    <h3 class="bd-content-title text-black mb-4">Get a quote today!</h3>

    <!-- <iframe id="form" src="https://go.maropost.com/l/597851/2019-05-02/5wq1q" width="100%" height="500" type="text/html" frameborder="0" allowTransparency="true" style="border: 0"></iframe> -->

    <ContactForm />

    <h3 class="bd-content-title text-black">Or contact us directly!</h3>
    <ul class="list-unstyled contact-list">
      <li>
        Phone:
        <a href="tel:`${phone}`" class="link">{{ phone }}</a>
      </li>
      <li>
        Email:
        <a href="mailto:`${email_placholder}`" class="link">{{ email_placholder }}</a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
.bd-content {
  overflow: scroll;
  height: 100%;
  display: block;
}
iframe {
  position: relative;
  transform: translateY(-10px);
}
.pardot-form {
  width: 105% !important;
}
</style>
<script>
import axios from "axios";

import { required, email } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";
import ContactForm from "@/components/ContactForm";

export default {
  name: "SideBar-Content",
  components: {
    ContactForm
  },
  data() {
    return {
      email_address: "",
      first_name: "",
      last_name: "",
      company: "",
      phone: "1.888.438.3152 Ext: 1",
      email_placholder: "sales@maropost.com",
      submitStatus: null
    };
  },
  props: {
    chosenIndustry: {
      type: String
    }
  }
};
</script>
